(function () {
  if (window.__eaceAccordionUniversalV2) return;
  window.__eaceAccordionUniversalV2 = true;

  var OPEN_MS = 220;
  var CLOSE_MS = 220;
  var EASING = "cubic-bezier(.22,.61,.36,1)";
  var REDUCED = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function getList(el) {
    return el.closest("[data-eace-accordion], collapsible-elements");
  }

  function allowsMultiple(list) {
    if (!list) return true;
    if (list.hasAttribute("data-allow-multiple")) {
      return list.getAttribute("data-allow-multiple") === "true";
    }
    if (list.hasAttribute("single")) {
      return list.getAttribute("single") !== "true";
    }
    return true;
  }

  function getItem(trigger) {
    return trigger.closest("details.eace-acc, details[data-collapsible], .eace-acc-item");
  }

  function isDetailsItem(item) {
    return item && item.tagName === "DETAILS";
  }

  function getTrigger(item) {
    return item.querySelector(
      "[data-eace-acc-trigger], .eace-acc__trigger, .eace-acc__sum, [data-collapsible-trigger], summary"
    );
  }

  function getPanel(item) {
    return item.querySelector(
      "[data-eace-acc-panel], .eace-acc__panel, .eace-acc__panel-wrap, [data-collapsible-body], .accordion__body"
    );
  }

  function isOpen(item) {
    return isDetailsItem(item) ? item.open : item.classList.contains("is-open");
  }

  function setOpenState(item, open) {
    var trigger = getTrigger(item);

    if (isDetailsItem(item)) {
      item.open = open;
      if (open) item.setAttribute("open", "");
      else item.removeAttribute("open");
    } else {
      item.classList.toggle("is-open", open);
    }

    if (trigger) trigger.setAttribute("aria-expanded", open ? "true" : "false");
  }

  function afterTransition(el, prop, fallback, done) {
    var finished = false;
    function finish() {
      if (finished) return;
      finished = true;
      el.removeEventListener("transitionend", onEnd);
      done();
    }
    function onEnd(e) {
      if (e.target !== el) return;
      if (prop && e.propertyName !== prop) return;
      finish();
    }
    el.addEventListener("transitionend", onEnd);
    setTimeout(finish, fallback);
  }

  function openItem(item) {
    var panel = getPanel(item);
    if (!panel || isOpen(item)) return Promise.resolve();

    setOpenState(item, true);
    panel.hidden = false;

    if (REDUCED) {
      panel.style.height = "auto";
      panel.style.opacity = "1";
      panel.style.transition = "";
      return Promise.resolve();
    }

    panel.style.overflow = "hidden";
    panel.style.height = "0px";
    panel.style.opacity = "0";
    panel.offsetHeight;

    panel.style.transition =
      "height " + OPEN_MS + "ms " + EASING + ", opacity 160ms ease";
    panel.style.height = panel.scrollHeight + "px";
    panel.style.opacity = "1";

    return new Promise(function (resolve) {
      afterTransition(panel, "height", OPEN_MS + 100, function () {
        panel.style.height = "auto";
        panel.style.transition = "";
        resolve();
      });
    });
  }

  function closeItem(item) {
    var panel = getPanel(item);
    if (!panel || !isOpen(item)) return Promise.resolve();

    if (REDUCED) {
      setOpenState(item, false);
      panel.style.height = "0px";
      panel.style.opacity = "0";
      panel.style.transition = "";
      if (!isDetailsItem(item)) panel.hidden = true;
      return Promise.resolve();
    }

    panel.style.overflow = "hidden";
    panel.style.height = panel.scrollHeight + "px";
    panel.style.opacity = "1";
    panel.offsetHeight;

    panel.style.transition =
      "height " + CLOSE_MS + "ms " + EASING + ", opacity 140ms ease";
    panel.style.height = "0px";
    panel.style.opacity = "0";

    return new Promise(function (resolve) {
      afterTransition(panel, "height", CLOSE_MS + 100, function () {
        setOpenState(item, false);
        if (!isDetailsItem(item)) panel.hidden = true;
        panel.style.transition = "";
        resolve();
      });
    });
  }

  function initItem(item) {
    var panel = getPanel(item);
    if (!panel) return;

    var open = isOpen(item);
    var trigger = getTrigger(item);
    if (trigger) trigger.setAttribute("aria-expanded", open ? "true" : "false");

    panel.style.overflow = "hidden";
    panel.style.height = open ? "auto" : "0px";
    panel.style.opacity = open ? "1" : "0";
    panel.style.transition = "";
    if (!isDetailsItem(item)) panel.hidden = !open;
  }

  function initRoot(root) {
    root
      .querySelectorAll("details.eace-acc, details[data-collapsible], .eace-acc-item")
      .forEach(initItem);
  }

  function handleToggle(trigger) {
    var item = getItem(trigger);
    var list = getList(trigger);
    var panel = item ? getPanel(item) : null;

    if (!item || !list || !panel) return;
    if (item.dataset.busy === "1") return;
    item.dataset.busy = "1";

    var currentlyOpen = isOpen(item);
    var run;

    if (currentlyOpen) {
      run = closeItem(item);
    } else {
      if (!allowsMultiple(list)) {
        var siblings = Array.prototype.slice
          .call(list.querySelectorAll("details.eace-acc, details[data-collapsible], .eace-acc-item"))
          .filter(function (other) {
            return other !== item && isOpen(other);
          });

        /* Cadence-like behavior: open new + close old at same time */
        run = Promise.all(
          [openItem(item)].concat(
            siblings.map(function (s) {
              return closeItem(s);
            })
          )
        );
      } else {
        run = openItem(item);
      }
    }

    Promise.resolve(run).finally(function () {
      item.dataset.busy = "";
    });
  }

  document.addEventListener("click", function (e) {
    var trigger = e.target.closest(
      "[data-eace-acc-trigger], .eace-acc__trigger, .eace-acc__sum, [data-collapsible-trigger], details.eace-acc > summary, details[data-collapsible] > summary"
    );
    if (!trigger) return;

    var item = getItem(trigger);
    var panel = item ? getPanel(item) : null;

    if (item && panel) {
      e.preventDefault();
      handleToggle(trigger);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Enter" && e.key !== " ") return;
    var trigger = e.target.closest(
      "[data-eace-acc-trigger], .eace-acc__trigger, .eace-acc__sum, [data-collapsible-trigger], details.eace-acc > summary, details[data-collapsible] > summary"
    );
    if (!trigger) return;
    e.preventDefault();
    handleToggle(trigger);
  });

  initRoot(document);

  document.addEventListener("shopify:section:load", function (e) {
    if (!e.target || !e.target.querySelectorAll) return;
    initRoot(e.target);
  });
})();
